import { type AvailabilityChartTheme, getAvailabilityChartTheme } from '../components/AvailabilityChart';
import { type ButtonTheme, getButtonTheme } from '../components/Buttons/theme';
import { type ChipThemeConfig, getChipThemeConfig } from '../components/Chip/theme';
import { type CircularProgressTheme, getCircularProgressTheme } from '../components/CircularProgress/theme';
import { type DependencyGraphTheme, getDependencyGraphTheme } from '../components/DependencyGraph';
import { type FiltersTheme, getFiltersTheme } from '../components/Filters/theme';
import { getInputTheme, type InputTheme } from '../components/Inputs/theme';
import { getListItems, type ListItemsTheme } from '../components/ListItems';
import { getModalThemeConfig, type ModalThemeConfig } from '../components/Modals/theme';
import { getPopperThemeConfig, type PopperThemeConfig } from '../components/Popper/theme';
import { getPricingFormTheme, type PricingFormTheme } from '../components/PricingForm/theme';
import { getRichTextFieldThemeConfig, type RichTextFieldTheme } from '../components/RichTextField';
import { statusTheme } from '../components/Status/theme';
import { getTableTheme, type TableTheme } from '../components/Table/theme';
import { getTabTheme, type TabTheme } from '../components/Tabs/theme';
import { getToDoListTheme, type ToDoListTheme } from '../components/ToDoList/theme';
import { getWorkstationTheme, type WorkstationTheme } from '../components/Workstation/theme';
import { type DowntimeReportWidgetTheme, getDowntimeReportWidgetTheme } from '../components/downtimeReportWidget';
import { defaultClientConfig } from './defaultClientConfig';

const defaultConfig = {
  brandColors: defaultClientConfig,
  buttons: getButtonTheme() as ButtonTheme,
  chip: getChipThemeConfig() as ChipThemeConfig,
  inputs: getInputTheme() as InputTheme,
  lists: getListItems() as ListItemsTheme,
  modals: getModalThemeConfig() as ModalThemeConfig,
  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  statuses: statusTheme as any,
  popper: getPopperThemeConfig() as PopperThemeConfig,
  table: getTableTheme() as TableTheme,
  filters: getFiltersTheme() as FiltersTheme,
  richTextField: getRichTextFieldThemeConfig() as RichTextFieldTheme,
  toDoList: getToDoListTheme() as ToDoListTheme,
  tabs: getTabTheme() as TabTheme,
  dependencyGraph: getDependencyGraphTheme() as DependencyGraphTheme,
  availabilityChart: getAvailabilityChartTheme(defaultClientConfig) as AvailabilityChartTheme,
  circularProgress: getCircularProgressTheme() as CircularProgressTheme,
  workstation: getWorkstationTheme() as WorkstationTheme,
  pricingForm: getPricingFormTheme() as PricingFormTheme,
  downtimeReportWidget: getDowntimeReportWidgetTheme() as DowntimeReportWidgetTheme,
} as const;

export type ClientConfig = typeof defaultConfig;

export function getClientConfig(): ClientConfig {
  return defaultConfig;
}
